export default __webpack_public_path__ + "static/media/weight_gray.1188ffd9.svg";